<template>
  <v-data-table
      :headers="headers"
      :items="images"
      :search="search"
      v-model="selected"
      item-key="id"
      class="elevation-1"
      hide-default-header
      :items-per-page="5"
      :footer-props="{ itemsPerPageOptions: [5] }"
      style="width: 350px; cursor: pointer;"
    >
    <template v-slot:item.url="{ item }">
      <v-img :src="item.url" max-height="100" max-width="100" @click="copyText(item.url)"
      ></v-img>
    </template>

    <template v-slot:item.title="{ item }">
      <span  @click="copyText(item.url)">{{item.title}}</span>
    </template>
    </v-data-table>
</template>

<script>
  // import moment from 'moment'
  import { copyTextToClipboard } from '../../../helpers/functions'

  export default {
    name: 'menu-data-table',
    data () {
      return {
        search: '',
        selected: [],
        headers: [
          {
            text: 'Image',
            align: 'left',
            sortable: false,
            value: 'url'
          },
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'title'
          }
        ]
      }
    },
    props: {
      images: {
        type: Array
      },
      menu: {
        type: String
      }
    },
    computed: {
    },
    methods: {
      copyText (text) {
        copyTextToClipboard(text)
      },
      copyURL (item) {
        console.log(item)
        const index = this.images.indexOf(item)
        copyTextToClipboard(this.images[index].url)
      },
      copyTextCloseMenu (text, id) {
        // NOTE: This does not work -> the button toggles menu state, so after doing this, the button needs to be clicked twice to continue
        document.getElementsByClassName(id)[0].style.display = 'none'
        this.copyText(text)
      }
    }
    // filters: {
    //   formatDate (date) {
    //     return moment(date).format('MMM DD')
    //   },
    //   formatTime (time) {
    //     const minutes = Math.floor(time / 60)
    //     return `${minutes}:${Math.floor(time - minutes * 60)}`
    //   }
    // },
  }
</script>
